// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","985":"component---src-pages-privacy-tsx"}[chunkId] || chunkId) + "-" + {"245":"03481dc52a9bb5a0b1ad","453":"72dab9878d05f184de58","454":"202d7469962cab39c60b","985":"fe51acfeaa8b9c0b0c31"}[chunkId] + ".js";
};